import {
  createFileRoute,
  Outlet,
  useParams,
  useMatches,
  useNavigate,
  useSearch,
} from "@tanstack/react-router";
import { useCallback } from "react";

import type { ProfilesSearch } from "./index";

import { PageContainer } from "@/features/Profiles/ProfilesPage.styles";
import { OrionBackButton } from "@/orion/OrionComponents/OrionBackButton";
import { OrionPageHeader } from "@/orion/OrionComponents/OrionPageHeader";

export const Route = createFileRoute("/_auth/people/$siteId/profiles")({
  component: RouteComponent,
});

const DEFAULT_PROFILES_LISTING_SEARCH: ProfilesSearch = {
  page: 1,
  pageSize: 20,
};

function RouteComponent() {
  const params = useParams({ strict: false });
  const siteId = String(params.siteId ?? "");
  const matches = useMatches();
  const navigate = useNavigate();
  const { profilesListingSearch } = useSearch({ strict: false });

  // // Check if we're on a profile detail page by looking for profileId in params or route matches
  const isDetailPage = Boolean(
    params.profileId ||
    matches.some((match) => match.routeId?.includes("$profileId")),
  );

  const handleBack = useCallback(() => {
    void navigate({
      to: "/people/$siteId/profiles",
      params: { siteId },
      search: profilesListingSearch ?? DEFAULT_PROFILES_LISTING_SEARCH,
    });
  }, [navigate, profilesListingSearch, siteId]);

  return (
    <>
      <PageContainer>
        <OrionPageHeader
          breadcrumbs={
            isDetailPage
              ? [
                  { label: "People" },
                  {
                    label: "Profiles",
                    to: "/people/$siteId/profiles",
                    params: { siteId },
                  },
                ]
              : [{ label: "People" }]
          }
          title="Profiles"
          actions={
            isDetailPage ? <OrionBackButton onBack={handleBack} /> : null
          }
        />
        <Outlet />
      </PageContainer>
    </>
  );
}
